import React, { useState, useRef, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
const Collapsible = ({ title, children, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(disabled ? 1 : -1);
  const togglePara = (value) => {
    setActive((oldValue) => {
      return oldValue === value ? -1 : value;
    });
  };

  return (
    <div className="Card my-4">
      <button
        type="button"
        className={`w-full  flex items-center  
          ${active === 1 ? '!text-primary' : ''}`}
        onClick={() => {
          togglePara(1);
          // toggleCollapse();
        }}>
        {title}
        <div className={`ltr:ml-auto rtl:mr-auto ${active === 1 ? 'rotate-180' : ''}`}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 9L12 15L5 9"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </button>
      <AnimateHeight duration={300} height={active === 1 ? 'auto' : 0}>
        <div className={'flex flex-col gap-4  mt-3 p-2 '}>{children}</div>
      </AnimateHeight>
    </div>
    // <div className="collapsible">
    //   <button
    //     onClick={toggleCollapse}
    //     className={`collapsible-header text-slate-600 text-sm leading-tight tracking-normal`}>
    //     {title}
    //   </button>
    //   <div className={`collapsible-content ${isOpen ? 'open' : ''}`} ref={contentRef}>
    //     {children}
    //   </div>
    // </div>
  );
};

export default Collapsible;
